import { assert } from '@varos/util-typescript';
import { IntegrationLoaderBaseConfig } from '../../../base';
import { ThreadUpsertLoader } from './integrationUpsertInterface';
import { ThreadUpsertAggregate } from './integrationUpsertModel';

export function createThreadUpsertLoader(
    config: IntegrationLoaderBaseConfig
): ThreadUpsertLoader {
    const { repository } = config;
    return {
        useLoad(context, props): ThreadUpsertAggregate {
            const integrationQuery = repository.platform.integration.useRetrieve(
                context,
                props.integration.id,
                {
                    suspense: true,
                }
            );
            assert(integrationQuery.status === 'success', 'expected suspense');

            const definitionQuery = repository.platform.integrationDefinition.useRetrieve(
                context,
                integrationQuery.data.definition_id,
                {
                    suspense: true,
                }
            );
            assert(definitionQuery.status === 'success', 'expected suspense');

            // Look for existing threads for this integration
            const threadsQuery = repository.assistant.local.thread.useFind(
                context,
                {},
                {
                    suspense: true,
                }
            );
            assert(threadsQuery.status === 'success', 'expected suspense');

            // Find thread by integration ID in metadata
            const existingThread = threadsQuery.data.find(
                (thread) => thread.metadata.integrationId === props.integration.id
            );

            // console.log('existingThread', existingThread);

            return {
                integration: integrationQuery.data,
                definition: definitionQuery.data,
                thread: existingThread || null,
            };
        },
    };
}
